module.exports = __webpack_public_path__ + "media/images/logo-badge-4d4e682a8c3e39b0cfaa19d42c3860d8.svg";